module.exports = __webpack_public_path__ + "img/map-bg.6365db02.png";